import React from 'react';

import {
    Box,
    Typography,
    Button,
    CircularProgress,
} from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Checkbox from '@mui/material/Checkbox';

import { formatTime, formatNumberWithSpaces } from './helpers';

const AssignmentPages = ({ setActiveStep, book, selectedChapters, setSelectedChapters, errorMessage }) => {

    const handleNext = (event) => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleToggle = (value) => () => {
        const currentIndex = selectedChapters.indexOf(value);
        const newChecked = [...selectedChapters];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setSelectedChapters(newChecked);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4, pb: 0, pt: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Make Selection</Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 7, pl: '100px', pr: '100px' }}>
                Specify which chapters you want your students to read.
            </Typography>

            {!book ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    {errorMessage ? <p style={{ color: 'red' }}>{errorMessage}</p> : <CircularProgress />}
                </div>
            ) : (
                <List sx={{ maxHeight: '260px', overflow: 'auto' }}>
                    {book.chapters.map((chapter, index) => {
                        if (chapter.lemmas === 0) {
                            return null;
                        }
                        return (
                            <ListItem key={index} role={undefined} dense button onClick={handleToggle(chapter)} sx={{ paddingY: 0 }}>
                                <Checkbox
                                    edge="start"
                                    checked={selectedChapters.indexOf(chapter) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    sx={{ paddingY: 0 }}
                                />
                                <Box display="flex" justifyContent="space-between" width="100%" gap="20px">
                                    <Typography variant="body1" noWrap sx={{textTransform: 'uppercase', fontWeight: 600, maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis'}}>{chapter.title}</Typography>
                                    <Typography variant="body1" sx={{textTransform: 'uppercase', color: 'grey', minWidth: '170px'}}>{
                                        chapter.duration > 0 ? formatTime(chapter.duration) + ' (' + formatNumberWithSpaces(chapter.tokens, 'words') + ')' :
                                        formatNumberWithSpaces(chapter.tokens, 'words')
                                    }</Typography>
                                </Box>
                            </ListItem>
                        );
                    })}
                </List>
            )}

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 5, mb: 0 }}
                onClick={handleNext}
                disabled={selectedChapters.length === 0}
            >
              Continue
            </Button>
        </Box>
    );
};

export default AssignmentPages;
